import {SendMessageAction} from '../../node.js';
import {outgoing} from '../../common/messages.js';
import {Subscribed, Event} from './types/messages.js';
import {busDomainUri} from './constants.js';
import {SubscriptionId} from '../../state/types/bus.js';
import {Identity, PeerId, Source} from '../../state/types/common.js';

export function event(recipient: Source, subscriberId: PeerId, subscriptionId: SubscriptionId, publisherIdentity: Identity, data): SendMessageAction<'event'> {
    const message: Event = {
        domain: busDomainUri,
        type: 'event',
        peer_id: subscriberId,
        subscription_id: subscriptionId,
        "publisher-identity": publisherIdentity,
        data
    }
    return outgoing(recipient, message)

}

export function subscribed(recipient: Source, requestId, subscriberId: PeerId, subscriptionId: SubscriptionId): SendMessageAction<'subscribed'> {
    const message: Subscribed = {
        domain: busDomainUri,
        type: 'subscribed',
        request_id: requestId,
        peer_id: subscriberId,
        subscription_id: subscriptionId
    }
    return outgoing(recipient, message);
}
